document.addEventListener("DOMContentLoaded", function () {
  class NewsletterPopup extends ModalDialog {
    constructor() {
      super();
      this.form = this.querySelector(".js-form");

      if (this.form) {
        this.form.addEventListener("submit", this.onSubscribe.bind(this));
      }

      this.setupAddToCartListener();
    }

    setupAddToCartListener() {
        document.querySelector('.newsletter_trigger').addEventListener('click',()=>{
        document.querySelector('[data-newsletter-content]').classList.remove('success');      
            this.show(); // ✅ Show the popup on homepage & product page
        });
    }

    hide() {
      super.hide();
    }

    onSubscribe() {
      if(document.querySelector('[data-thank-you]') != undefined)
      document.querySelector('[data-newsletter-content]').classList.add('success');
      else
      this.hide();
    }
  }

  customElements.define("newsletter-popup", NewsletterPopup);
});
document.getElementById('cardClear').addEventListener('click',(el)=>{
    el.stopPropagation();
    el.currentTarget.parentElement.remove();
});